import {BooleanRouteOption} from './boolean-route-option';
import {ActivatedRouteSnapshot} from '@angular/router';
import {FinancialHealthSeriesOption} from '../financial-health-series';

export class DisplayIndicatorBenchmarkRouteOption extends BooleanRouteOption {
	constructor(
		route: ActivatedRouteSnapshot,
		defaultValue = false,
	) {
		super(
			FinancialHealthSeriesOption.displayIndicatorBenchmark,
			route,
			defaultValue
		);
	}
}
